function set(state, fn) {
	if (fn)
		fn(state);
}

export default {
	set
};